import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';
import { isBrowser } from '../../Utils/CommonUtils';

const win = (window as any);
declare var navigator;

@Injectable()
export class ConnectionProvider {

	constructor(
		private apiProvider: ApiProvider
	) {

	}

	getConnection() {
		return this.apiProvider.get("testconnection");
	}

	checkConnection() {

		return new Promise((resolve, reject) => {
			let ctype = "NONE"

			if (navigator.connection) {
				ctype = navigator.connection.type;
			} else if (!win.Ionic.platform.is("android") && !win.Ionic.platform.is("ios") && !win.Ionic.platform.is("ipad")) {
				ctype = navigator.connection.effectiveType;
			}
			if (ctype == "Ethernet" || ctype == "unknown" || ctype == undefined) {
				ctype = "wifi"
			}

			if (ctype == "4g" || ctype == "3g") {
				ctype = "cell"
			}
			let proceed = "NO_PROCEED";
			if(ctype == "wifi"|| ctype == "cell"){
				let test = ctype;
				test = "wifi"
				let user: any = localStorage.getItem("user");

				if (user && user.usemobiledata == "true" || test.indexOf("wifi") > -1) {
					proceed = "PROCEED";
				} else {
					if (navigator.connection && navigator.connection.type.includes("cell")) {
						proceed = "CELL_NOT_ENABLED";
					} else if (!win.Ionic.platform.is("android") || !win.Ionic.platform.is("ios") || !win.Ionic.platform.is("ipad")) {
						proceed = "CELL_NOT_ENABLED";
					}
				}
			}
			else{
				let proceed = "NO_PROCEED";
			}
			if (proceed == "PROCEED") {
				let connectionPromise = this.getConnection().toPromise();
				connectionPromise.then((data) => {
					resolve(proceed)
				}).catch(() => {
					reject(false);
				})
			} else {
				resolve(proceed);
			}

		})

	}

	isOnline() {
		
		if(navigator.onLine)
			return true;
		else 
			return false;

	}

	getConnectionType() {

		// return "wifi";
		if (!isBrowser()) {
			let connectionType = navigator.connection.type;
			return connectionType;
		} else {
			let effectiveConnectionType = navigator.connection.effectiveType;
			return effectiveConnectionType;
		}
	}

}



// WEBPACK FOOTER //
// ./src/providers/connection/connection.ts